import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {District} from "../../generated-model/model";
import {IgnoreNullHttpParams} from "../shared/commons/Ignore-null-http-params";
import {Observable} from "rxjs";

@Injectable({providedIn: "root"})
export class SubDistrictResource {
  http = inject(HttpClient);

  public search(term: string, districtId?: string): Observable<District[]> {
    return this.http.get<District[]>(`${environment.serverUrl}/api/subdistrict`, {
      params: IgnoreNullHttpParams.fromObject({term: term, districtId: districtId}).toHttpParam()
    });
  }
}
